// Copyright (c) 2020 Deere & Company

import './index.scss';

import AuthenticatedPage from '../../common/components/authenticated-page';
import OrderAvailability from './orderAvailability';
import React from 'react';

function OrderAvailabilityPage () {

    return (
        <AuthenticatedPage className="atp-page atp-order-availability-page">
            <OrderAvailability />
        </AuthenticatedPage>
    );

}
OrderAvailabilityPage.displayNAme = 'OrderAvailabilityPage';

export default OrderAvailabilityPage;
